<template>
  <div class="contest-result">
    <!-- 成绩卡片 -->
    <div class="result-card">
      <!-- 右上角装饰图案 -->
      <div class="card-decoration"></div>
      <div class="result-content" v-if="dataLoaded">
        <div class="score-section">
          <span class="score-value">{{ totalScore }}</span>
          <span class="score-unit">分</span>
        </div>
        <div class="congrats-text">恭喜您，已完成作答</div>
        <div class="stats-section">
          <div class="stat-item">
            <span class="stat-label">答题耗时：</span>
            <span class="stat-value">{{ formatDuration(totalDuration,totalTime) }}</span>
          </div>
<!--          <div class="stat-item">-->
<!--            <span class="stat-label">当前排名：</span>-->
<!--            <span class="stat-value" v-if="Number(totalScore) > 0">第{{ userRank }}名</span>-->
<!--            <span class="stat-value" v-else>不计入排名</span>-->
<!--          </div>-->
        </div>
<!--        <div-->
<!--          class="view-record"-->
<!--          v-track="{functionName: `${ranking.length > 0 && ranking[0].title ? ranking[0].title : ''}竞赛答题-查看答题记录`}"-->
<!--          @click="handleViewRecord"-->
<!--        >-->
<!--          查看我的答题记录 >-->
<!--        </div>-->
      </div>
    </div>

    <!-- 排行榜 -->
<!--    <div class="ranking-section">-->
<!--      <div class="ranking-title">-->
<!--        <span class="title-text">{{title || ''}}排行榜</span>-->
<!--      </div>-->
<!--      <div class="ranking-list">-->
<!--        <template v-if="ranking && ranking.length > 0">-->
<!--          <div-->
<!--            class="ranking-item"-->
<!--            :class="{ 'is-self': item.userId === userInfo.id }"-->
<!--            v-for="item in ranking"-->
<!--            :key="item.userRank"-->
<!--          >-->
<!--            <div-->
<!--              class="col-rank"-->
<!--              :class="item.userRank <= 3 ? `rank-${item.userRank}` : ''"-->
<!--            >-->
<!--              <span v-if="item.userRank > 3" class="rank-number">{{ item.userRank }}.</span>-->
<!--            </div>-->
<!--            <div class="col-avatar">-->
<!--              <img-->
<!--                v-if="item.headPicUrl"-->
<!--                :src="item.headPicUrl"-->
<!--                class="user-avatar"-->
<!--                alt=""-->
<!--              />-->
<!--              <span v-else class="avatar-placeholder"></span>-->
<!--            </div>-->
<!--            <div class="col-info">-->
<!--              <div class="user-name">{{ item.hcpName }}</div>-->
<!--              <div class="user-hospital">{{ item.hcpHospital }}</div>-->
<!--            </div>-->
<!--            <div class="col-score">{{ item.score }}分</div>-->
<!--          </div>-->
<!--        </template>-->
<!--        <div v-else class="replay-none">-->
<!--          <img src="@/assets/images/home/live_none.png" class="none-img" alt="暂无排名数据"/>-->
<!--          <div class="none-txt">暂无排名数据</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {getExamRank} from '@/api/contest'
import withRouteTracking from '@/utils/withRouteTracking'
import {getExamRemainingTime} from '../../api/contest'

const ContestResult = {
  name: 'ContestResult',
  data() {
    return {
      totalScore: 0,
      totalDuration: 0,
      userRank: 0,
      ranking: [],
      title: '',
      totalTime: 0,
      dataLoaded: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    // 员工不能参加竞赛（memberType === 0 表示术者）
    if (this.userInfo.memberType !== 0) {
      this.$tipsDialog.alert({
        message: '仅术者可参加竞赛',
        confirmButtonText: '我知道了',
        // decorationImage: require('@/assets/images/decorationImage.png'),
      }).finally(() => {
        this.$router.replace('/home')
      })
      return
    }
    this.initResult()
  },
  beforeDestroy() {
    this.$tipsDialog.close()
  },
  methods: {
    alertAndGoHome(message) {
      this.$tipsDialog.alert({
        message,
        confirmButtonText: '我知道了'
      }).finally(() => {
        this.$router.replace('/home')
      })
    },
    async initResult() {
      try {
        const contestId = this.$route.query.contestId
        const { code, data } = await getExamRemainingTime(contestId)
        if (code !== 0 || !data) return

        const {
          examStatus, // 0 未开始 1 进行中 2 已结束
          isAnswered, // 0 未参加 1 已参加(已结束) 2 进行中
          title,
          startTime
        } = data

        this.title = title

        const startDateLabel = this.formatStartDate(startTime)

        // 考试状态校验（最高优先级）
        const examStatusMessageMap = {
          0: startDateLabel ? `比赛还未开始，请${startDateLabel}再来哦` : '比赛还未开始，请稍后再来哦',
          2: '比赛已结束，感谢关注，下次再来哦！'
        }

        if (examStatusMessageMap[examStatus]) {
          this.alertAndGoHome(examStatusMessageMap[examStatus])
          return
        }

        // 参赛状态校验
        if (isAnswered !== 1) {
          this.alertAndGoHome('请参赛后再来查看')
          return
        }

        // 获取排名列表
        const res = await getExamRank(contestId)
        if (res.code !== 0 && res.data.length === 0) return
        // 从排名列表中筛选当前用户的成绩
        const userId = this.userInfo.id
        const currentUser = res.data.find(item => item.userId === userId)
        if (currentUser) {
          this.totalScore = currentUser.score || 0
          this.totalDuration = currentUser.duration || 0
          this.totalTime = currentUser.totalTime || 0
          this.userRank = currentUser.userRank || 0
          this.dataLoaded = true
        } else {
          // 成绩还没出来，需要有提示
          this.$tipsDialog.alert({
            message: '竞赛成绩计算中，请稍后查看',
            confirmButtonText: '我知道了',
            // decorationImage: require('@/assets/images/decorationImage.png'),
          }).finally(() => {
            this.$router.replace('/home')
          })
        }
        this.ranking = res.data || []
        // 过滤掉0分数据
        this.ranking = this.ranking.filter(item => item.score > 0)
      } catch (error) {
        if (error.code === 30002) {
          this.$toast({
            message: error.message || error.msg || '竞赛未发布',
            duration: 1500,
            onClose: () => {
              this.$router.replace('/home')
            }
          })
          return
        }
        this.$toast(error.message || error.msg || '获取信息失败')
      }
    },
    formatDuration(seconds, totalTime) {
      const duration = seconds === -1 ? totalTime : seconds
      const safeSeconds = Number(duration) || 0
      const minutes = Math.floor(safeSeconds / 60)
      const secs = safeSeconds % 60
      return `${minutes}分${secs}秒`
    },
    formatStartDate(dateStr) {
      if (!dateStr) return ''
      const datePart = dateStr.split(' ')[0]
      const parts = datePart.split('-')
      if (parts.length < 3) return ''
      const month = Number(parts[1])
      const day = Number(parts[2])
      if (!month || !day) return ''
      return `${month}月${day}日`
    },
    handleViewRecord() {
      // 跳转到答题回顾页面
      this.$router.push({
        path: '/contest',
        query: {
          contestId: this.$route.query.contestId,
          isReview: 'true'
        }
      })
    }
  }
}

export default withRouteTracking(ContestResult)
</script>

<style lang="less" scoped>
.contest-result {
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  background-image: url('~@/assets/images/contest/bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.result-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;

  .card-decoration {
    width: 100%;
    height: 241px;
    background-image: url('~@/assets/images/contest/trophy.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .result-content {
    margin: 0 16px;
    padding: 39px 0 35px 0;
    background: rgba(253, 253, 253, 0.7);
    border-radius: 16px;
    .congrats-text {
      margin-top: 21px;
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 3px;
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      background: linear-gradient(90deg, #0B0101 0%, #7C1D1F 50%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      display: flex;
      align-items: center;
      justify-content: center;

      &::before,
      &::after {
        content: '';
        display: inline-block;
        width: 17px;
        height: 17px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        flex-shrink: 0;
      }

      &::before {
        background-image: url('~@/assets/images/contest/decorationLeft.png');
        margin-right: 5px;
      }

      &::after {
        background-image: url('~@/assets/images/contest/decorationRight.png');
        margin-left: 5px;
      }
    }

    .score-section {
      text-align: center;
      line-height: 1;
      font-weight: bold;
      .score-value {
        font-size: 72px;
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        background: linear-gradient(90deg, #0B0101 0%, #7C1D1F 50%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .score-unit {
        font-size: 20px;
        color: #5F2D08;
        margin-left: 4px;
      }
    }

    .stats-section {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      gap: 6px;
      color: #611618;
      font-weight: 700;
      .stat-item {
        font-size: 20px;
        text-align: center;
        .stat-label {
          text-align: center;
        }

        .stat-value {
          text-align: center;
        }
      }
    }

    .view-record {
      margin-top: 47px;
      font-size: 14px;
      color: #611618;
      cursor: pointer;
      text-align: center;
    }
  }
}

.ranking-section {
  background-color: #fff;
  border-radius: 12px;
  padding: 15px 0;
  margin: 0 15px;

  .ranking-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;

    .title-text {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 6px;
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      background: linear-gradient(90deg, #0B0101 0%, #7C1D1F 50%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      display: flex;
      align-items: center;

      &::before,
      &::after {
        content: '';
        width: 17px;
        height: 17px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }

      &::before {
        background-image: url('~@/assets/images/contest/decorationLeft.png');
        margin-right: 5px;
      }

      &::after {
        background-image: url('~@/assets/images/contest/decorationRight.png');
        margin-left: 5px;
      }
    }
  }

  .ranking-list {
    .ranking-item {
      display: flex;
      align-items: center;
      padding: 12px 15px;
      border-bottom: 1px solid #f9f9f9;

      &.is-self {
        background-color: rgba(235, 23, 0, 0.05);
      }

      &:last-child {
        border-bottom: none;
      }

      .col-rank {
        width: 28px;
        height: 28px;
        text-align: center;
        flex-shrink: 0;
        margin-right: 14px;
        // 奖牌图标 - 预留背景图位置
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

        &.rank-1 {
          // 金牌
          background-image: url('~@/assets/images/contest/1.png');
          background-color: #FFD700;
          border-radius: 50%;
        }

        &.rank-2 {
          // 银牌
          background-image: url('~@/assets/images/contest/2.png');
          background-color: #C0C0C0;
          border-radius: 50%;
        }

        &.rank-3 {
          // 铜牌
          background-image: url('~@/assets/images/contest/3.png');
          background-color: #CD7F32;
          border-radius: 50%;
        }

        .rank-number {
          font-weight: bold;
          font-size: 20px;
          font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
          background: linear-gradient(90deg, #0B0101 0%, #7C1D1F 50%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 26px;
        }
      }

      .col-avatar {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        flex-shrink: 0;

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }

        .avatar-placeholder {
          display: block;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #f0f0f0;
          // 默认头像 - 预留背景图位置
          // background-image: url('~@/assets/images/default-avatar.png');
          // background-size: cover;
        }
      }

      .col-info {
        flex: 1;
        min-width: 0;
        overflow: hidden;

        .user-name {
          font-size: 14px;
          color: #000;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .user-hospital {
          font-size: 12px;
          font-weight: 400;
          color: #5B5F6A;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .col-score {
        font-size: 18px;
        color: #000000;
        font-weight: 600;
        flex-shrink: 0;
        margin-left: 17px;
      }
    }
  }
  .replay-none {
    display: block;

    .none-img {
      width: 185px;
      margin-top: 122px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .none-txt {
      text-align: center;
      font-size: 12px;
      color: #949ba5;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contest/contestResult.vue